import React from 'react';

function ExperienceItem({ date, title, company, description, items, isCurrent }) {
    return (
        <div className="relative mb-12">
            <div className="timeline-dot"></div>
            <div className="flex flex-col gap-1 mb-2">
                <span className={`text-xs font-bold uppercase tracking-widest ${isCurrent ? 'text-primary dark:text-sky-300' : 'text-slate-500 dark:text-sky-300'}`}>{date}</span>
                <h3 className="text-xl font-bold">{title}</h3>
                <p className="text-primary dark:text-sky-300 font-semibold">{company}</p>
            </div>
            <p className="text-slate-600 dark:text-slate-400 text-sm leading-relaxed mb-4">
                {description}
            </p>
            <ul className="space-y-2">
                {items.map((item, index) => (
                    <li key={index} className="flex items-start gap-2 text-sm text-slate-500 dark:text-slate-400">
                        <span className="text-primary dark:text-sky-300 mt-1 material-symbols-outlined text-xs">arrow_forward</span>
                        {item}
                    </li>
                ))}
            </ul>
        </div >
    );
}

export default ExperienceItem;
